import styled from 'styled-components';

interface BaseProps {
    $isHovering?: boolean;
    $error?: boolean;
    $fullBorder?: boolean;
}

interface InputProps {
    $height?: string;
    $inputTextCentered: boolean;
}

interface PortalProps {
    $top: number;
    $left: number;
}

export const Base = styled.div<BaseProps>`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: inherit;
    height: ${(props) => (props.$fullBorder ? '100%' : '')};
    border-bottom: ${(props) => {
        if (props.$isHovering && !props.$error && !props.$fullBorder) {
            return `1px solid ${props.theme.accent}`;
        } else if (!props.$fullBorder) {
            return props.$error
                ? `1px solid ${props.theme.error}`
                : `1px solid ${props.theme.lightBorder}`;
        }
    }};

    border: ${(props) => {
        if (props.$isHovering && !props.$error && props.$fullBorder) {
            return `1px solid ${props.theme.accent}`;
        } else if (props.$fullBorder) {
            return props.$error
                ? `1px solid ${props.theme.error}`
                : `1px solid ${props.theme.lightBorder}`;
        }
    }};

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: 'color 9999s ease-out, background-color 9999s ease-out';
        transition-delay: 9999s;
    }
`;

export const Input = styled.input<InputProps>`
    width: 100%;
    line-height: 1.5;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 1.2rem;
    height: ${(props) => (props.$height ? `${props.$height}` : '2.5rem')};
    outline: none;

    color: ${({ theme }) => theme.text};

    flex: 1;

    &::placeholder {
        color: ${({ theme }) => theme.text};
        opacity: 0.42;
        font-size: 1rem;
    }

    text-align: ${(props) => (props.$inputTextCentered ? 'center' : '')};

    &:disabled {
        color: ${({ theme }) => theme.disabled};
    }
`;

export const Img = styled.div`
    width: 30px;
    height: 30px;
    position: relative;
    top: 4px;

    .rotate {
        animation: rotation 0.5s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const ImgAsFont = styled.div`
    width: 25px;
    position: relative;
    top: 6px;
    font-size: 28px;
`;

export const InformationBox = styled.div`
    position: relative;
    top: 10px;
`;

export const PortalBox = styled.div<PortalProps>`
    position: fixed;
    top: ${(props) => `${props.$top}px`};
    left: ${(props) => `${props.$left}px`};
    z-index: 9999;
`;
